<template>
    <div class="main">
        <c-panel title="FUNÇÕES GRATIFICADAS" titleIcon="fas fa-hand-holding-usd">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Catálogo das funções gratificadas da rede."
                description="A gratificação é vinculada à LOTAÇÃO do servidor, não ao servidor: a mesma pessoa pode tê-la em uma lotação e não em outra."></el-alert>

            <el-row class="u-mb-15" :gutter="10">
                <el-col :xs="24" :sm="14">
                    <el-input v-model="filtro.nome" placeholder="Pesquisar por nome ou código..." @keyup.native.enter="carregar"></el-input>
                </el-col>
                <el-col :xs="24" :sm="10" class="u-text-right">
                    <router-link v-if="podeEscrever" to="/admin/funcao-gratificada/cadastro" class="btn-new-register">
                        <el-button type="primary">NOVA FUNÇÃO</el-button>
                    </router-link>
                </el-col>
            </el-row>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Função</th>
                            <th style="width: 120px;">Código</th>
                            <th style="width: 150px;" class="u-text-right">Valor de referência</th>
                            <th class="hidden-mobile">Base legal</th>
                            <th style="width: 100px;" class="u-text-center">Situação</th>
                            <th style="width: 120px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="f in items" :key="f.id">
                            <td>{{ f.nome }}</td>
                            <td>{{ f.codigo || '—' }}</td>
                            <td class="u-text-right">{{ f.valor_referencia !== null ? moeda(f.valor_referencia) : '—' }}</td>
                            <td class="hidden-mobile">{{ f.base_legal || '—' }}</td>
                            <td class="u-text-center">{{ f.situacao ? 'Ativa' : 'Inativa' }}</td>
                            <td class="u-text-center acao">
                                <router-link v-if="podeEscrever" :to="'/admin/funcao-gratificada/edit/' + f.id" class="link-icon u-mr-10" style="color: rgba(0,0,0,.87) !important;">
                                    <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
                                </router-link>
                                <el-button v-if="podeEscrever" @click="excluir(f.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="6" class="u-text-center">Nenhuma função gratificada cadastrada.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO G — item 27. Interface para `api/funcao-gratificada`. */
export default {
    data: () => ({ statusList: false, filtro: { nome: '' }, items: [] }),
    computed: {
        podeEscrever () { return [4, 5, 6, 7].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () { this.carregar() },
    methods: {
        carregar () {
            this.statusList = false
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/funcao-gratificada/getAllPaginate?page=1`,
                this.filtro, this.$store.getters.getHeaderAuth
            ).then(r => { this.items = r.data.data || []; this.statusList = true })
             .catch(e => this.$store.commit('throwException', e))
        },
        moeda (v) {
            return 'R$ ' + Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
        excluir (id) {
            this.$confirm('Excluir esta função gratificada?', 'Confirmação', {
                confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar', type: 'warning'
            }).then(() => {
                this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/funcao-gratificada/delete/${id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: 'Função excluída.', type: 'success' })
                    this.carregar()
                }).catch(e => this.$store.commit('throwException', e))
            }).catch(() => {})
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
